export default "__VITE_ASSET__BapLHNdr__"